import { Icon, type IconName } from "@components";

import styled from "styled-components";

export const StyledButton = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 8px;
  background: var(--on-primary);
  color: var(--text-subheading);

  &:hover:enabled {
    background: linear-gradient(
        0deg,
        var(--dark-tint) 0%,
        var(--dark-tint) 100%
      ),
      var(--on-primary);
  }
`;

type IconButtonProps = {
  onClick: () => void;
  icon: IconName;
  size?: number;
};

export const IconButton = ({ onClick, icon, size = 24 }: IconButtonProps) => {
  return (
    <StyledButton onClick={onClick}>
      <Icon name={icon} width={size} height={size} />
    </StyledButton>
  );
};
